import {BACKEND_URL} from "./Constants";

export const links = {
    token: BACKEND_URL+'/token',
    getKunde: BACKEND_URL+'/kunde',
    getKontakte: BACKEND_URL+'/kontakte',
    getAenderungen: BACKEND_URL+'/aenderung',
    postAenderungen: BACKEND_URL+'/aenderung',
    getAllAenderungen: BACKEND_URL+'/aenderungen',
    approveAenderung: BACKEND_URL+'/aenderungen/approve/',
    rejectAenderung: BACKEND_URL+'/aenderungen/reject/',
    getModule: BACKEND_URL+'/module',
    getSupportCenter: BACKEND_URL + '/kundenzentrum'
};